/**
 * reservation api: reservation-controller
 * 预约管理 https://doc.apipost.net/docs/detail/4810535f00a9000?target_id=479b3637e085000
 */
import httpRequest from "@/utils/request";
import { ReservationSettingParams, ApplyReservationParams } from "./types";

/**
 * 获取医生预约配置
 * @param param
 * @returns
 */
const getDoctorReservationSetting = (param: any) => {
    return httpRequest({
        url: `/reservation/setting?doctorUserId=${param.id}`,
        method: "get"
    });
};

/**
 * 医生预约配置(新增or修改)
 * @param param
 * @returns
 */
const setDoctorReserationSetting = (param: ReservationSettingParams) => {
    return httpRequest({
        url: `/reservation/addOrUpdate`,
        method: "post",
        data: param,
    });
};

/**
 * 医生当日可申请的预约时间
 * getReservationAllAppointment
 * @param param
 */
const getReservationAppointmentTimes = (param: {
    id: string;
    selectTime: string;
}) => {
    return httpRequest({
        url: `/reservation/appointmentTimes/?doctorUserId=${param.id}&selectTime=${param.selectTime}`,
        method: "get",
    });
};

/**
 * 预约申请
 * @param param
 * @returns
 */
const applyDoctorReserationService = (param: ApplyReservationParams) => {
    return httpRequest({
        url: `/reservation/reservationApply`,
        method: "post",
        data: param,
    });
};

/**
 * 医生当日的所有预约时间
 * getReservationAllAppointment
 * @param param
 */
const getReservationAllAppointment = (param: {
    id: string;
    selectTime: string;
}) => {
    return httpRequest({
        url: `/reservation/allAppointment/?doctorUserId=${param.id}&selectTime=${param.selectTime}`,
        method: "get",
    });
};

/**
 * 医生处理预约
 * @param param  预约id 操作状态
 * @returns
 */
const getReservationDoctorHandle = (param: { id: string; state: number }) => {
    return httpRequest({
        url: `/reservation/doctorHandle?kaReservationId=${param.id}&state=${param.state}`,
        method: "get",
    });
};

/**
 * 关闭/开启预约
 * @param param 医生id || 所选时间 || 1开启 2关闭
 * @returns
 */
const closeAndOpenReservation = (param: {
    id: string;
    selectTime: string;
    state: number;
}) => {
    return httpRequest({
        url: `/reservation/closeAndOpen?doctorUserId=${param.id}&selectTime=${param.selectTime}&state=${param.state}`,
        method: "get",
    });
};

/**
 * 关闭/开启预约
 * @param param 医生id || 所选时间 || 1开启 2关闭
 * @returns
 */
const closeAndOpenSoltReservation = (param: {
    id: string;
    selectTime: string;
    displayTime: string;
    state: number;
}) => {
    return httpRequest({
        url: `/reservation/slotCloseAndOpen?doctorUserId=${param.id}&selectTime=${param.selectTime}&displayTime=${param.displayTime}&state=${param.state}`,
        method: "get",
    });
};

/**
 * 预约月日历数据
 * getReservationMonthlyCalendar
 * @param param 医生id || 所选时间
 */
const getReservationMonthlyCalendar = (param: {
    id: string;
    selectTime: string;
}) => {
    return httpRequest({
        url: `/reservation/monthlyCalendar/?doctorUserId=${param.id}&selectTime=${param.selectTime}`,
        method: "get",
    });
};

/**
 * 我的预约
 * @param param
 * @returns
 */
const getMyAllReservation = (param?: any) => {
    return httpRequest({
        url: `/reservation/myReservation`,
        method: "get",
        params: param,
    });
};

/**
 * 用户取消预约
 * @param param  预约id
 * @returns
 */
const cancelReservationByUser = (param: { id: string }) => {
    return httpRequest({
        url: `/reservation/userHandle?kaReservationId=${param.id}`,
        method: "get",
    });
};

/**
 * 修改预约申请
 * @param param
 * @returns
 */
const updateApplyReservatonSetting = (param: ApplyReservationParams) => {
    return httpRequest({
        url: `/reservation/updateApply`,
        method: "post",
        data: param,
    });
};

export default {
    getDoctorReservationSetting,
    setDoctorReserationSetting,
    getReservationAppointmentTimes,
    applyDoctorReserationService,
    getReservationAllAppointment,
    getReservationDoctorHandle,
    closeAndOpenReservation,
    closeAndOpenSoltReservation,
    getReservationMonthlyCalendar,
    getMyAllReservation,
    cancelReservationByUser,
    updateApplyReservatonSetting,
};
